<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
  <ul class="list-none">
    @for (item of data; track item.id) {
    <li>
      <mat-checkbox (change)="toggleSelection(item.id)" [value]="item.id">
        {{ item.name || item.label || item.title }}
      </mat-checkbox>
    </li>
    }
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close (click)="deleteSelected()"
    [disabled]="selectedItems.length === 0">{{submitButton}}</button>
</mat-dialog-actions>
